import EDC from '../../shared/globals';

/**
 *
 */
EDC.Games.ImagesToTextSpace.Question = function (scene) {
  this.scene = scene;
  this.container = null;
  this.text = null;
  this.data = null;
  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Question.prototype.create = function () {
  this.container = this.scene.add.container(0, 0);
  const frame = this.scene.add.sprite(0, 0, 'question-frame');
  this.text = this.scene.add
    .text(0, 0, '', {
      fontFamily: 'Arial',
      fontSize: 75,
      fontStyle: 'bold',
      color: '#ffffff',
      stroke: '#000000',
      strokeThickness: 6,
      shadow: {
        color: '#666666',
        offetX: 5,
        offsetY: 5,
        blur: 8,
        stroke: true,
      },
    })
    .setOrigin(0.5);
  this.container.add([frame, this.text]);

  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Question.prototype.place = function (x, y) {
  this.container.setPosition(x, y);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Question.prototype.appear = function () {};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Question.prototype.setData = function (data) {
  this.data = data;
  this.text.setText(data.text);
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Question.prototype.getValue = function () {
  return this.data.text;
};

export default EDC.Games.ImagesToTextSpace.Question;
